import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import SectionHeading from "@/components/feature/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import BlogHero from "@/pages/blog/components/BlogHero";
import CategoryGrid from "@/pages/blog/components/CategoryGrid";
import FeaturedPosts from "@/pages/blog/components/FeaturedPosts";
import PopularPosts from "@/pages/blog/components/PopularPosts";
import RecentPosts from "@/pages/blog/components/RecentPosts";
import GuidesSection from "@/pages/blog/components/GuidesSection";
import BlogNewsletter from "@/pages/blog/components/BlogNewsletter";
import { generalFaqs } from "@/pages/blog/blogData";

export default function Blog() {
  return (
    <SiteLayout>
      <Seo
        title="Blog NXHOST | Tecnologia, Sites, Hospedagem, SEO e Marketing"
        description="Central de conhecimento da NXHOST com conteúdos práticos sobre hospedagem, criação de sites, domínios, servidores, SEO, banco de dados, marketing digital e Google Ads."
        keywords="blog de tecnologia, hospedagem de sites, criação de sites, SEO, marketing digital, VPS, domínios, banco de dados, Google Ads, tutoriais"
        path="/blog"
        titleEn="NXHOST Blog | Technology, Websites, Hosting, SEO and Marketing"
        titleEs="Blog NXHOST | Tecnología, Sitios Web, Hosting, SEO y Marketing"
        descriptionEn="NXHOST knowledge center with practical content about hosting, website creation, domains, servers, SEO, databases, digital marketing and Google Ads."
        descriptionEs="Centro de conocimiento de NXHOST con contenido práctico sobre hosting, creación de sitios web, dominios, servidores, SEO, bases de datos y marketing digital."
        faqs={generalFaqs}
        breadcrumbs={[{ name: "Início", path: "/" }, { name: "Blog", path: "/blog" }]}
      />

      <BlogHero />
      <CategoryGrid />
      <FeaturedPosts />
      <PopularPosts />
      <RecentPosts />
      <GuidesSection />

      <section className="bg-background-100 py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <SectionHeading
            badge="Perguntas frequentes"
            badgeIcon="ri-question-line"
            title="Perguntas frequentes sobre o blog"
            description="Dúvidas comuns de quem chega até aqui buscando resolver um problema ou aprender algo novo."
          />
          <div className="mt-12">
            <FaqAccordion items={generalFaqs} />
          </div>
        </div>
      </section>

      <BlogNewsletter />
    </SiteLayout>
  );
}